import styled from 'styled-components';
import { useScrollFadeIn } from 'hooks/useScrollFadeIn';

import ClientLogo from 'resources/videoLanding/clients_logo.png';
import MobileClientLogo from 'resources/videoLanding/clients_logo_m.png';

const Clients = () => {

  const bottomUpAnime = useScrollFadeIn({threshold: 0.1, delay: '0.3', direction: 'bottomUp'});

  return (
    <Container className='client'>
      <ClientsContainer>
        <div {...bottomUpAnime}>
          <Title>클라이언트</Title>
          <ImageBox><img src={ClientLogo} /></ImageBox>
          <MobileImageBox><img src={MobileClientLogo} /></MobileImageBox>
        </div>
      </ClientsContainer>
    </Container>
  )
}

export default Clients;

const Container = styled.div`
  display: flex;
  width: 100%;  
  margin: 0 auto;
  background: #000000;
`

const ClientsContainer = styled.div`
  width: 1088px;
  // height: 898px;
  margin: 0 auto;
  padding: 180px 0;

  img {
    opacity: 0.9;
  }

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    // height: 738px;
    margin: 0;
    padding: 80px 16px;
  }
`

const Title = styled.div`
  margin-bottom: 80px;
  text-align: center;
  color: #FFFFFF;
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;

  @media ${({theme}) => theme.device.mobile} {
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
  }
`

const ImageBox = styled.div`
  width: 100%;
  height: 490px;
  text-align: center;

  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`

const MobileImageBox = styled(ImageBox)`
  display: none;

  @media ${({theme}) => theme.device.mobile} {
    display: block;
    height: 759px;
  }
`